import SingleActivityParticipantsModal  from './single-activity-participants-container'
export default SingleActivityParticipantsModal
